// components/session/SessionBooking/styles.js
import styled from 'styled-components';

export const BookingWrapper = styled.div`
    padding: ${props => props.theme.spacing.xl};
    background: ${props => props.theme.colors.background.main};
`;

export const BookingHeader = styled.div`
    text-align: center;
    margin-bottom: ${props => props.theme.spacing.xl};

    h2 {
        font-size: ${props => props.theme.typography.sizes['2xl']};
        color: ${props => props.theme.colors.text.primary};
        margin-bottom: ${props => props.theme.spacing.sm};
    }

    p {
        color: ${props => props.theme.colors.text.secondary};
    }
`;

export const BookingGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: ${props => props.theme.spacing.xl};
    max-width: 1200px;
    margin: 0 auto;

    @media (max-width: ${props => props.theme.breakpoints.md}) {
        grid-template-columns: 1fr;
    }
`;

export const CalendarSection = styled.div`
    background: white;
    padding: ${props => props.theme.spacing.xl};
    border-radius: ${props => props.theme.borderRadius.lg};
    box-shadow: ${props => props.theme.shadows.sm};

    h3 {
        font-size: ${props => props.theme.typography.sizes.xl};
        margin-bottom: ${props => props.theme.spacing.sm};
    }

    p {
        color: ${props => props.theme.colors.text.secondary};
        margin-bottom: ${props => props.theme.spacing.lg};
    }

    .react-datepicker-wrapper {
        width: 100%;
    }
`;

export const TimeSlotSection = styled.div`
    background: white;
    padding: ${props => props.theme.spacing.xl};
    border-radius: ${props => props.theme.borderRadius.lg};
    box-shadow: ${props => props.theme.shadows.sm};

    h3 {
        font-size: ${props => props.theme.typography.sizes.xl};
        margin-bottom: ${props => props.theme.spacing.lg};
    }

    .time-slots {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
        gap: ${props => props.theme.spacing.md};
    }

    p {
        color: ${props => props.theme.colors.text.secondary};
        text-align: center;
        padding: ${props => props.theme.spacing.xl};
    }
`;

export const TimeSlot = styled.button`
    padding: ${props => props.theme.spacing.md};
    border: 1px solid ${props => props.selected ? props.theme.colors.primary.main : props.theme.colors.border};
    border-radius: ${props => props.theme.borderRadius.md};
    background: ${props => props.selected ? props.theme.colors.primary.main : 'white'};
    color: ${props => props.selected ? 'white' : props.theme.colors.text.primary};
    cursor: pointer;
    transition: all ${props => props.theme.transitions.normal};

    &:hover {
        border-color: ${props => props.theme.colors.primary.main};
        background: ${props => props.selected ? props.theme.colors.primary.main : props.theme.colors.primary.main + '15'};
    }
`;

export const BookingSummary = styled.div`
    background: white;
    padding: ${props => props.theme.spacing.xl};
    border-radius: ${props => props.theme.borderRadius.lg};
    box-shadow: ${props => props.theme.shadows.sm};

    h3 {
        font-size: ${props => props.theme.typography.sizes.xl};
        margin-bottom: ${props => props.theme.spacing.xl};
    }

    button {
        width: 100%;
        margin-top: ${props => props.theme.spacing.xl};
    }
`;

export const FormGroup = styled.div`
    margin-bottom: ${props => props.theme.spacing.lg};

    &:last-of-type {
        margin-bottom: 0;
    }

    p {
        color: ${props => props.theme.colors.text.primary};
        margin-top: ${props => props.theme.spacing.xs};
    }

    select {
        width: 100%;
        padding: ${props => props.theme.spacing.md};
        border: 1px solid ${props => props.theme.colors.border};
        border-radius: ${props => props.theme.borderRadius.md};
        font-family: inherit;
        font-size: inherit;
        color: ${props => props.theme.colors.text.primary};
        background: white;

        &:focus {
            outline: none;
            border-color: ${props => props.theme.colors.primary.main};
        }
    }
`;

export const Label = styled.label`
    display: block;
    margin-bottom: ${props => props.theme.spacing.xs};
    color: ${props => props.theme.colors.text.secondary};
    font-size: ${props => props.theme.typography.sizes.sm};
`;

export const TextArea = styled.textarea`
    width: 100%;
    padding: ${props => props.theme.spacing.md};
    border: 1px solid ${props => props.theme.colors.border};
    border-radius: ${props => props.theme.borderRadius.md};
    font-family: inherit;
    font-size: inherit;
    resize: vertical;
    min-height: 100px;

    &:focus {
        outline: none;
        border-color: ${props => props.theme.colors.primary.main};
    }
`;